export default __webpack_public_path__ + "static/media/chevron-down-black.a8b46bdb.svg";